import { BaseGameScene } from '@/features/laneChooserPhaser/game/scenes/BaseGameScene';

import type { LaneChooserEventBus } from '@/features/laneChooserPhaser/game/EventBus';
import type { LaneChooserGameTheme } from '@/features/laneChooserPhaser/game/types';

export const getLaneChooserThemeSceneKey = (themeKey: string) => `laneChooserTheme-${themeKey}`;

export class LaneChooserThemeScene extends BaseGameScene {
	protected readonly themeSceneConfig: LaneChooserGameTheme;

	constructor(eventBus: LaneChooserEventBus, themeConfig: LaneChooserGameTheme) {
		super(getLaneChooserThemeSceneKey(themeConfig.key), eventBus);
		this.themeSceneConfig = themeConfig;
	}
}
